var cov_1zm7g86hb1 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/accept.tsx",
      hash = "e9d66a5e4411252a7dd528b2bdbd4a22c820f4ad",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/accept.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 10,
          column: 3
        }
      },
      "1": {
        start: {
          line: 7,
          column: 38
        },
        end: {
          line: 7,
          column: 48
        }
      },
      "2": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 101
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 15
          },
          end: {
            line: 4,
            column: 16
          }
        },
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 5
          }
        },
        loc: {
          start: {
            line: 6,
            column: 13
          },
          end: {
            line: 9,
            column: 5
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 48
          },
          end: {
            line: 8,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 48
          },
          end: {
            line: 8,
            column: 59
          }
        }, {
          start: {
            line: 8,
            column: 63
          },
          end: {
            line: 8,
            column: 69
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/accept.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
export default (function (Component) {
  cov_1zm7g86hb1.f[0]++;
  cov_1zm7g86hb1.s[0]++;
  return (
    /*#__PURE__*/
    function (_React$PureComponent) {
      _inherits(_class, _React$PureComponent);

      var _super = _createSuper2(_class);

      function _class() {
        _classCallCheck(this, _class);

        return _super.apply(this, arguments);
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          cov_1zm7g86hb1.f[1]++;

          var _ref = (cov_1zm7g86hb1.s[1]++, this.props),
              forceAccept = _ref.forceAccept,
              accept = _ref.accept;

          cov_1zm7g86hb1.s[2]++;
          return (
            /*#__PURE__*/
            React.createElement(Component, Object.assign({}, this.props, {
              accept: (cov_1zm7g86hb1.b[0][0]++, forceAccept) || (cov_1zm7g86hb1.b[0][1]++, accept),
              forceAccept: !!forceAccept,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 8,
                columnNumber: 14
              }
            }))
          );
        }
      }]);

      return _class;
    }(React.PureComponent)
  );
});